import React from 'react';
import BrokerWiseCrossAuthLogo from '../PreLoginConsent/BrokerWiseCrossAuthLogo';

const BrandDetails = () => {
  return <BrokerWiseCrossAuthLogo />;
};

export default BrandDetails;
